export const formatFullAddress = (
  addressLineOne: string,
  addressLineTwo: string,
  city: string,
  stateProvince: string,
  postalCode: string,
  country: string
): string => {
  return [
    addressLineOne,
    addressLineTwo,
    city,
    stateProvince,
    postalCode,
    country,
  ]
    .filter((text) => text?.trim().length > 0)
    .join(', ')
}
